// extracted by mini-css-extract-plugin
export default {"live":"style_live__6-ZRg","activeDot":"style_activeDot__dKobv","deactivedDot":"style_deactivedDot__82Ek8"};